cliente.component('clienteMenuComponent', {
    templateUrl: 'components/menu/menu.html',
    controller: 'menuComponentController',
    controllerAs: '$menu',
    bindings: { hideNav: '<', menuItems:'<', usuario: '<' }
});

cliente.controller('menuComponentController', ['$state', '$transitions', 'coreLanguage', '$document', '$scope', function($state, $transitions, $text, $document, $scope) {
    const $ctrl = this;

    $ctrl.accountLabel = $text.menu.account;
    $ctrl.showDrawer = false;

    $ctrl.isActive = (route) => {
        return $state.current.name.startsWith(route);
    }

    $ctrl.toggleDrawer = () => {
        $ctrl.showDrawer = !$ctrl.showDrawer;
    }

    $transitions.onFinish({}, () => {
        $ctrl.showDrawer = false;
    });

    const handleClickOutside = (event) => {
        const sidebarElem = document.querySelector('.pc-sidebar');
        const menuToggle = document.getElementById('menu-toggle');

        if ((sidebarElem && menuToggle) && (!sidebarElem.contains(event.target) && !menuToggle.contains(event.target))) {
            if($ctrl.showDrawer){
                $ctrl.showDrawer = false;
                $scope.$apply();
            }
        }
    };

    $document.on('click', handleClickOutside);

    $ctrl.$onDestroy = () => {
        $document.off('click', handleClickOutside);
    };

}]);